export const TYPES = {
  POLYLINE: 'POLYLINE',
  POLYGON: 'POLYGON',
  MARKER: 'MARKER',
}



// WEBPACK FOOTER //
// ./src/Components/GMap/DisplayMap/const.js